import { createFileRoute } from '@tanstack/react-router'
import ContactSelectionLists from 'Contact/components/Contact/Sections/ContactSelectionLists'

export const Route = createFileRoute('/contact/$contactId/lists')({
    component: ContactSelectionLists,
})
